
interface PageLayoutProps {
  children?: React.ReactNode
  scrollEnabled?: boolean
}

/**
 * PageLayout — base wrapper for all pages.
 *
 * - Consistent padding (p-10) and vertical gap between children
 * - Children are stacked vertically (flex-col)
 * - Takes the full width and height of the available area
 *
 * scrollEnabled (default: false)
 * 
 * - false → h-full:     page fills exactly the viewport (e.g. with PageCard flex-1)
 * - true  → min-h-full: page can grow beyond the viewport and becomes scrollable
 *                       (for content-heavy pages, e.g. detail pages)
 */
export function PageLayout({ children, scrollEnabled = false }: PageLayoutProps) {
  return (
    <div className={`flex flex-col w-full gap-4 p-10 bg-background/50 ${scrollEnabled ? 'min-h-full' : 'h-full'}`}>
      {children}
    </div>
  )
}